var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFindDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9374 9.03445C19.4558 3.96527 15.1866 0 9.99133 0C4.47327 0 0 4.47327 0 9.99133C0 15.1866 3.96527 19.4558 9.03445 19.9374C10.4086 22.3631 13.0131 24 16 24C17.4843 24 18.8741 23.5958 20.0655 22.8915L20.5887 23.4147C21.3691 24.1951 22.6343 24.1951 23.4147 23.4147C24.1951 22.6344 24.1951 21.3691 23.4147 20.5887L22.8914 20.0655C23.5958 18.8741 24 17.4843 24 16C24 13.0131 22.3631 10.4086 19.9374 9.03445ZM8.03079 16.7068C8.01041 16.4739 8 16.2382 8 16C8 11.5817 11.5817 8 16 8C16.2382 8 16.4739 8.01041 16.7068 8.03079C15.8591 5.12244 13.1734 2.9974 9.99133 2.9974C6.12869 2.9974 2.9974 6.12869 2.9974 9.99133C2.9974 13.1734 5.12244 15.8591 8.03079 16.7068ZM23 16C23 19.866 19.866 23 16 23C12.134 23 9 19.866 9 16C9 12.134 12.134 9 16 9C19.866 9 23 12.134 23 16ZM12.875 14.9091L16 10L19.125 14.9091L19.1236 14.9104C19.672 15.6573 20 16.605 20 17.6364C20 20.0463 18.2091 22 16 22C13.7909 22 12 20.0463 12 17.6364C12 16.605 12.328 15.6573 12.8764 14.9104L12.875 14.9091ZM19 18.7273C19 19.9323 18.1045 20.9091 17 20.9091C15.8954 20.9091 15 19.9323 15 18.7273C15 17.5223 15.8954 16.5455 17 16.5455C18.1045 16.5455 19 17.5223 19 18.7273Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindDrop);
export default __webpack_public_path__ + "static/media/FindDrop.8e98bb57b80ec10eff0477bc537c1f59.svg";
export { ForwardRef as ReactComponent };